import { ActionType, ErrorCode } from "../constants";
// import { setUserSession } from "../service/AuthService";
const testing = false;
const initialState = {
  testing: testing,
  accountData: {
    firstName: null,
    lastName: null,
    contactInfo: null,
    contactType: null,
    loginToken: null,
    verified: true,
    accountType: null,
  },
  jobs: null,
  error: null,
  uncaughtError: null,

  profilePicUrl: null,
  profilePicScale: null,
  loadedProfilePic: false,
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.setProfilePicUrl:
        return {
          ...state,
          profilePicUrl: action.payload.url,
          profilePicScale: action.payload.scale,
          loadedProfilePic: true,
        };
      case ActionType.setUserData:
        const clearError =
          state.error !== ErrorCode.noJobMatches &&
          state.error !== ErrorCode.noSurveyData;
        const newState = {
          ...state,
          error: clearError ? null : state.error,
          uncaughtError: clearError ? null : state.uncaughtError,
          accountData: {
            ...state.accountData,
            ...action.payload,
          },
        };
        console.log("newUserData", newState);
        return newState;
      case ActionType.removeLocalJobById:
        return {
          ...state,
          jobs: state.jobs.filter((job) => job.jobId !== action.payload),
        };
      case ActionType.setJobs:
        console.log("setting jobs", action.payload);
        return {
          ...state,
          error: null,
          uncaughtError: null,
          jobs: action.payload,
        };
      case ActionType.toggleFavJob:
        return {
          ...state,
          jobs: state.jobs.map((job) => {
            if (job.jobId === action.payload.jobId) {
              return {
                ...job,
                isFav: action.payload.isFav,
              };
            }
            return job;
          }),
        };
      case ActionType.logout:
        return {
          ...state,
          error: null,
          uncaughtError: null,
          accountData: {
            ...initialState.accountData,
          },
        };
      case ActionType.error:
        return {
          ...state,
          error: action.payload.error_code,
          uncaughtError:
            action.payload.uncaughtError !== undefined
              ? action.payload.uncaughtError
              : null,
        };

      default:
        return state;
    }
  } catch (e) {
    console.log("authReducer error:", e);
  }
};
